function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { getElementDeserializer, getToggleElementOnKeyDown } from '@udecode/plate-common';
import { getPlatePluginOptions, getEditableRenderElement } from '@udecode/plate-core';
var ELEMENT_H1 = 'h1';
var ELEMENT_H2 = 'h2';
var ELEMENT_H3 = 'h3';
var ELEMENT_H4 = 'h4';
var ELEMENT_H5 = 'h5';
var ELEMENT_H6 = 'h6';
var KEYS_HEADING = [ELEMENT_H1, ELEMENT_H2, ELEMENT_H3, ELEMENT_H4, ELEMENT_H5, ELEMENT_H6];
var DEFAULT_HEADING_LEVEL = 6;
var DEFAULTS_H1 = {
  hotkey: ['mod+opt+1', 'mod+shift+1']
};
var DEFAULTS_H2 = {
  hotkey: ['mod+opt+2', 'mod+shift+2']
};
var DEFAULTS_H3 = {
  hotkey: ['mod+opt+3', 'mod+shift+3']
};
var getHeadingDeserialize = function getHeadingDeserialize() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$levels = _ref.levels,
    levels = _ref$levels === void 0 ? DEFAULT_HEADING_LEVEL : _ref$levels;
  return function (editor) {
    var h1 = getPlatePluginOptions(editor, ELEMENT_H1);
    var h2 = getPlatePluginOptions(editor, ELEMENT_H2);
    var h3 = getPlatePluginOptions(editor, ELEMENT_H3);
    var h4 = getPlatePluginOptions(editor, ELEMENT_H4);
    var h5 = getPlatePluginOptions(editor, ELEMENT_H5);
    var h6 = getPlatePluginOptions(editor, ELEMENT_H6);
    var deserializers = getElementDeserializer(_objectSpread({
      type: h1.type,
      rules: [{
        nodeNames: 'H1'
      }]
    }, h1.deserialize));
    if (levels >= 2) deserializers = [].concat(_toConsumableArray(deserializers), _toConsumableArray(getElementDeserializer(_objectSpread({
      type: h2.type,
      rules: [{
        nodeNames: 'H2'
      }]
    }, h2.deserialize))));
    if (levels >= 3) deserializers = [].concat(_toConsumableArray(deserializers), _toConsumableArray(getElementDeserializer(_objectSpread({
      type: h3.type,
      rules: [{
        nodeNames: 'H3'
      }]
    }, h3.deserialize))));
    if (levels >= 4) deserializers = [].concat(_toConsumableArray(deserializers), _toConsumableArray(getElementDeserializer(_objectSpread({
      type: h4.type,
      rules: [{
        nodeNames: 'H4'
      }]
    }, h4.deserialize))));
    if (levels >= 5) deserializers = [].concat(_toConsumableArray(deserializers), _toConsumableArray(getElementDeserializer(_objectSpread({
      type: h5.type,
      rules: [{
        nodeNames: 'H5'
      }]
    }, h5.deserialize))));
    if (levels >= 6) deserializers = [].concat(_toConsumableArray(deserializers), _toConsumableArray(getElementDeserializer(_objectSpread({
      type: h6.type,
      rules: [{
        nodeNames: 'H6'
      }]
    }, h6.deserialize))));
    return {
      element: deserializers
    };
  };
};

/**
 * Font sizes are relative to the base font size
 * H1 - fs * 20/11
 * H2 - fs * 16/11
 * H3 - fs * 14/11
 * H4 - fs * 12/11
 * H5 - fs * 1
 * H6 - fs * 1
 */
var getHeadingRenderElement = function getHeadingRenderElement() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$levels = _ref2.levels,
    levels = _ref2$levels === void 0 ? DEFAULT_HEADING_LEVEL : _ref2$levels;
  return function (editor) {
    var h1 = getPlatePluginOptions(editor, ELEMENT_H1);
    var h2 = getPlatePluginOptions(editor, ELEMENT_H2);
    var h3 = getPlatePluginOptions(editor, ELEMENT_H3);
    var h4 = getPlatePluginOptions(editor, ELEMENT_H4);
    var h5 = getPlatePluginOptions(editor, ELEMENT_H5);
    var h6 = getPlatePluginOptions(editor, ELEMENT_H6);
    var renderElementsOptions = [];
    var checkRenderElement = function checkRenderElement(level, optionsValues) {
      if (levels >= level) renderElementsOptions.push(optionsValues);
    };
    checkRenderElement(1, h1);
    checkRenderElement(2, h2);
    checkRenderElement(3, h3);
    checkRenderElement(4, h4);
    checkRenderElement(5, h5);
    checkRenderElement(6, h6);
    return getEditableRenderElement(renderElementsOptions);
  };
};

/**
 * Enables support for headings with configurable levels
 * (from 1 to 6).
 */
var createHeadingPlugin = function createHeadingPlugin() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$levels = _ref3.levels,
    levels = _ref3$levels === void 0 ? DEFAULT_HEADING_LEVEL : _ref3$levels;
  return {
    pluginKeys: KEYS_HEADING,
    renderElement: getHeadingRenderElement({
      levels: levels
    }),
    deserialize: getHeadingDeserialize({
      levels: levels
    }),
    onKeyDown: getToggleElementOnKeyDown(KEYS_HEADING)
  };
};
export { DEFAULTS_H1, DEFAULTS_H2, DEFAULTS_H3, DEFAULT_HEADING_LEVEL, ELEMENT_H1, ELEMENT_H2, ELEMENT_H3, ELEMENT_H4, ELEMENT_H5, ELEMENT_H6, KEYS_HEADING, createHeadingPlugin, getHeadingDeserialize, getHeadingRenderElement };